import type { IconData } from '@stacksjs/iconify-core'

export const yinYangSymbol: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 24c0-11.598-9.402-21-21-21S3 12.402 3 24s9.402 21 21 21s21-9.402 21-21Z\"/><path d=\"M24 45c-5.799 0-10.5-4.701-10.5-10.5S18.201 24 24 24s10.5-4.701 10.5-10.5S29.799 3 24 3\"/><path d=\"M27.5 34.5a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0Zm0-21a3.5 3.5 0 1 0-7 0a3.5 3.5 0 0 0 7 0Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default yinYangSymbol
